import React, { useState, useEffect } from 'react';
import DetailIcon from '@/common/detail-icon';
import doLog from '@/common/log';
import './index.less';
import MyLazyComponent from '@/common/lazy-load';
import PageStore from '@/stores/page';

export default function Index(props: { promoConfig: string; i18n: DetailTypes.i18n }) {
  const [isShow, setShow] = useState(false);
  const { promoConfig, i18n } = props;
  const atmosphereInfo: AtmosphereTypes.Root = JSON.parse(promoConfig);
  const { ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP, DETAIL_BELT_ATOMOSPHERE = [] } = atmosphereInfo || {};
  if (DETAIL_BELT_ATOMOSPHERE.length === 0) return null;
  if (!DETAIL_BELT_ATOMOSPHERE[0].materialJSON?.styles?.logoImg) return null;
  useEffect(() => {
    doLog('/sc.details.atmosphere', '', 'EXP');
  }, []);

  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;

  const AtmDialog = MyLazyComponent(() => import('./dialog'));

  return (
    <>
      {/* 大促氛围腰带 */}
      <div
        className="detail-promotion-layout"
        onClick={() => {
          doLog('/sc.details.atmosphere');
          setShow(true);
        }}
      >
        <div className="promotion-info">
          <img src={DETAIL_BELT_ATOMOSPHERE[0].materialJSON.styles.logoImg} />
          <div className="promotion-item">
            {DETAIL_BELT_ATOMOSPHERE[0].materialJSON?.texts?.title}
          </div>
        </div>
        <DetailIcon className="detail-icon-right" symbol="icon-right" width="20" height="20" />
      </div>
      {/* 大促氛围解释弹窗 */}
      {isLoaded && (
        <AtmDialog isShow={isShow} setShow={setShow} i18n={i18n}>
          <div className="atmosphere-dialog">
            <img src={ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP[0].materialJSON.styles.logoImg} />
            <div className="atmosphere-body">
              {ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP.map((item) => (
                <div
                  className="atmosphere-item"
                  style={{
                    backgroundColor:
                      ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP[0].materialJSON.styles.backgroundColor,
                  }}
                >
                  <div className="atmosphere-title">{item.materialJSON.texts.title}</div>

                  <div
                    className="atmosphere-info"
                    dangerouslySetInnerHTML={{
                      __html: item.materialJSON.texts.title2,
                    }}
                  />
                  {item.materialJSON.texts.bottomTitle && (
                    <div
                      className="atmosphere-logo"
                      dangerouslySetInnerHTML={{
                        __html: item.materialJSON.texts.bottomTitle,
                      }}
                    ></div>
                  )}
                </div>
              ))}
            </div>
            <a
              href={ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP[0].materialJSON.texts.viewMoreLinkPC}
              onClick={() => {
                doLog('/sc.details.atmosphereLink', '', 'EXP');
              }}
              target="_blank"
              className="atmosphere-link"
            >
              {ICBU_DETAIL_BELT_ATOMOSPHERE_POPUP[0].materialJSON.texts.tc}
            </a>
          </div>
        </AtmDialog>
      )}
    </>
  );
}
